import React from "react";
import {PageHeader, Card, Radio, Row, Col, Form, Input, Select, DatePicker, Button, Divider, Breadcrumb} from 'antd';
import BaseComponent from "../../redare/components/BaseComponent";
import {WebPage} from "../../redare_components/webplatform_workbench/utils/WorkbenchDecoratorUtil";
import {Link} from "react-router-dom";
import RolePermissionPage from "../../redare_components/webplatform_workbench/pages/role/RolePermissionPage";

export default @WebPage({
    classify: '用户角色管理',
    id: 'com.redare.webmanager.pages.user.UserRoleManagerPage',
    name: '角色权限管理',
    webPath: '/role/permission/manager',
    webFunIds: [
        'WebPlatformRolePermissionAddFun',
        'WebPlatformRolePermissionAddMenu',
        'WebPlatformRolePermissionDelFun',
        'WebPlatformRolePermissionDelMenu',
        'WebPlatformRoleModify',
        'WebPlatformRoleDel',
        'WebPlatformRoleAdd'
    ]
})
class UserRoleManagerPage extends BaseComponent {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="ReportPushConfiguration-Page">
                <div className="bg-white bord-bot">
                    <div className="width-all padding02">
                        <Breadcrumb>
                            <Breadcrumb.Item><Link to="/">工作台</Link></Breadcrumb.Item>
                            <Breadcrumb.Item><Link to="/site">系统设置</Link></Breadcrumb.Item>
                            <Breadcrumb.Item>角色管理</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </div>
                <div className="width-all">
                    <div className="margin024">
                        <RolePermissionPage/>
                    </div>
                </div>
            </div>
        )
    }
}
